import styled from "styled-components";

interface Props {
  color?: "default" | "red" | "yellow";
}

const Button = styled.button<Props>`
  background: ${({ color = "default" }) => colors[color].background};
  border: none;
  border-radius: 4px;
  color: ${({ color = "default" }) => colors[color].color};
  cursor: pointer;
  padding: 0.75rem 1.25rem;
  position: relative;
  transition: background-color 0.5s ease;
  outline: none;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.75;
  }

  &:hover:not([disabled]) {
    background: ${({ color = "default" }) => colors[color].hoverBackground};
    color: ${({ color = "default" }) => colors[color].hoverColor};
  }

  @media (max-width: 600px) {
    text-align: center;
    width: 100%;

    span {
      text-align: center;
      width: 100%;
    }
  }
`;

const colors = {
  default: {
    background: "#212121",
    color: "#fff",
    hoverBackground: "#bdbdbd",
    hoverColor: "#ccc"
  },
  red: {
    background: "#ff1744",
    color: "#fff",
    hoverBackground: "#f31000",
    hoverColor: "#ccc"
  },
  yellow: {
    background: "#fdc002",
    color: "#fff",
    hoverBackground: "#fdc002",
    hoverColor: "#fff"
  }
};

export default Button;
